import React from "react";
import { Form } from "antd";
import { Select } from "@/scenes/OrderManagement/components/OrderTable/SearchPane/BaseSelect";
import LogisticsCompanySelect from "@/components/LogisticsCompanySelect";

interface LogisticsCompanyFieldProps {}

const LogisticsCompanyField: React.FC<LogisticsCompanyFieldProps> = () => {
    return (
        <Form.Item label={<span className="search-field-label">快递公司</span>} name="logisticsCompany">
            <LogisticsCompanySelect
                prioritizeTemplate
                placeholder=""
                popupMatchSelectWidth={false}
                style={{ fontSize: 13, width: 110 }}
                size="small"
                RenderedSelect={Select}
                extraOptions={[{ value: "", label: "" }]}
            />
        </Form.Item>
    );
};

export default React.memo(LogisticsCompanyField);
